import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import AMZMemberDay from '@elem/compCommon/PillarPageActivities/AMZMemberDay';
import A from './components/A';
import css from './index.module.scss';
import Banner from './v2Components/Banner';
import J from './v2Components/J';
import MillionHomes from './v2Components/MillionHomes';
import N from './v2Components/N';
import Preparing from './v2Components/Preparing';
import AuPreparing from './v2Components/AuPreparing';
import AuFaq from './v2Components/AuFaq';
import Protection from './v2Components/Protection';
import Recommended from './v2Components/Recommended';
import Reference from './v2Components/Reference';
import Risk from './v2Components/Risk';
import Voices from './v2Components/Voices';
import Why from './v2Components/Why';
import 'elem/compPage/battery-backup-for-home/scroll-animation-v2/animations.scss';
import ForumEntry from '@elem/compCommon/CommunityEntry';
import Certified from './v2Components/Certified';
import Retailers from './v2Components/Retailers';
import Instant from './v2Components/Instant';
import Global from './v2Components/Global';
import EfScrollAni from '@/efscrollani';
import SceneProducts from '@elem/compCommon/SceneProducts';
import { useGlobal } from '@/utils/useGlobal';
import PdfBar from '@elem/compCommon/PdfBar';
// import PDBar from '@elem/compCommon/PDBar';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });
const BATTERY_BACKUP_FOR_HOME_PRODUCTS = [
    {
        link_more:
            'https://energy.ecoflow.com/au/products/ocean-2-plus-single-phase-home-battery?utm_source=efweb&utm_medium=link&utm_campaign=energy_saving_webpage',
        title: 'EcoFlow OCEAN 2 Plus Single-Phase',
        descArr: ['60kWh Capacity', '12kW Output Power'],
        img: '/responsive/picture/cost-saving/au/ocean-2-plus-single-phase-home-battery.png',
    },
];
export default function BatteryBackupForHome() {
    const { locale } = useRouter();
    const { useLang } = useGlobal();
    const { t } = useLang('costsaving-new');
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    if (locale === 'us') {
        return (
            <div className={`power-backup ${css['power-backup']}`}>
                {/* <PDBar /> */}
                <Banner />
                <PdfBar site="us" />
                <MillionHomes />
                <Risk />
                <Preparing />
                <Why />
                <Certified />
                <Voices />
                <Recommended />
                <Protection />
                <Retailers />
                <Instant />
                <Global />
                <N />
                <Reference />
                <ForumEntry communityLink="https://www.ecoflow.com/us/battery-backup-for-home?utm_source=website_scenario2" />
            </div>
        );
    }
    if (locale === 'au') {
        return (
            <div className={`power-backup ${css['power-backup']}`}>
                {/* <PDBar /> */}
                <Banner />
                <MillionHomes />
                <Risk />
                <AuPreparing />
                <Why />
                <J />
                <AuFaq />
            </div>
        );
    }
    return (
        <div className={`power-backup ${css['power-backup']}`}>
            <A />
            {['us', 'ca'].includes(locale as string) && <AMZMemberDay />}
            <IndexDynamic />
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
